/* Copyright 2013 - 2024 Waiterio LLC */
import isLoggedInSession from './isLoggedInSession.js'

export default function useLoggedInSession() {
  if (typeof window !== 'undefined' && !isLoggedInSession()) {
    window.location = '/login'
  }
}
